import { pathOr } from 'ramda';

import { IState } from '../../store';

export const selectTimezone = (state: IState) => {
  const timezone = pathOr<number | null>(null, ['offerData', 'offer', 'timezone'], state);

  return timezone;
};
